mutation RotateOverlayTokens($eventId: ID!) {
  rotation: StreamToolsRotateOverlayTokens(eventId: $eventId) {
    eventId
    overlayTokenVersion
  }
}
